export const messageBoardConstants = {
  GET_SHUTTERB_BY_EVENT_ID: "GET_SHUTTERB_BY_EVENT_ID",
  FORM_STATE_OF_MESSAGE_BOARD: "FORM_STATE_OF_MESSAGE_BOARD",
  SEND_MESSAGE: "SEND_MESSAGE",
  GET_MESSAGES: "GET_MESSAGES",
  RECEIVE_MESSAGES: "RECEIVE_MESSAGES",
  GET_SB_BY_ID: "GET_SB_BY_ID",
  HOST :"host",
  SHUTTERB : "shutterb"
};